import { useEffect, useState } from "react";
import { IntroOverlay, INTRO_DEFAULTS, IntroSettings } from "@/components/hero-lab/IntroOverlay";

type NumKey = "totalMs" | "drawMs" | "openMs";
const SLIDERS: { k: NumKey; label: string; min: number; max: number; step: number }[] = [
  { k: "totalMs", label: "Total length (ms)", min: 800, max: 4000, step: 50 },
  { k: "drawMs", label: "Line draw (ms)", min: 150, max: 1500, step: 25 },
  { k: "openMs", label: "Seam opening (ms)", min: 250, max: 1800, step: 25 },
];

const IntroLab = () => {
  const [s, setS] = useState<IntroSettings>(INTRO_DEFAULTS);
  const [run, setRun] = useState(0);
  const [loop, setLoop] = useState(true);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    document.title = "Intro Lab | Damian Keyes";
    const m = document.createElement("meta"); m.name = "robots"; m.content = "noindex"; document.head.appendChild(m);
    return () => m.remove();
  }, []);

  const onDone = () => { if (loop) window.setTimeout(() => setRun((r) => r + 1), 1400); };
  const copy = () => { navigator.clipboard.writeText(JSON.stringify(s)); setCopied(true); setTimeout(() => setCopied(false), 1500); };

  return (
    <div className="relative h-[100svh] overflow-hidden bg-hero-human">
      <IntroOverlay key={run} s={s} fixed={false} onDone={onDone} />
      <div className="absolute right-4 top-4 z-[70] w-72 space-y-3 rounded-lg border border-border bg-background/95 p-4 font-mono text-xs text-foreground shadow-lg">
        <div className="font-semibold uppercase tracking-widest">Intro controls</div>
        {SLIDERS.map(({ k, label, min, max, step }) => (
          <label key={k} className="block">
            <div className="flex justify-between"><span>{label}</span><span>{s[k]}</span></div>
            <input type="range" className="w-full" min={min} max={max} step={step} value={s[k]}
              onChange={(e) => setS({ ...s, [k]: Number(e.target.value) })} />
          </label>
        ))}
        <label className="flex items-center gap-2"><input type="checkbox" checked={s.counter} onChange={(e) => setS({ ...s, counter: e.target.checked })} /> Loader counter</label>
        <label className="flex items-center gap-2"><input type="checkbox" checked={loop} onChange={(e) => setLoop(e.target.checked)} /> Loop</label>
        <div className="flex gap-2">
          <button className="flex-1 rounded bg-foreground px-2 py-1.5 text-background" onClick={() => setRun((r) => r + 1)}>Replay</button>
          <button className="flex-1 rounded border border-border px-2 py-1.5" onClick={copy}>{copied ? "Copied" : "Copy values"}</button>
        </div>
      </div>
    </div>
  );
};

export default IntroLab;
